import React,{useState,useCallback} from 'react'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import SiteSeo from '../../components/components/seo/SiteSeo'
import { useTranslation } from 'next-i18next'
import Main from '../../components/components/Term/Main';
import KeyWordsHelper from "../../components/components/KeyWords/KeyWordsHelper"
import KeyWordsData from '../../components/components/KeyWords/KeyWords'
import {getKeywordsForBlogs} from '../api/cms/keywords/helper'
import {dehydrate} from '@tanstack/react-query'
import {queryClient} from '../../react-query-config/queryClient'
function index(props) {
  const [privacyPolicy,setprivacyPolicy]=useState([])
  const callback = useCallback(
    back => {
      setprivacyPolicy(back)
    },
    [privacyPolicy]
  );
    const {t}=useTranslation("common")
  
    let meta
    if(privacyPolicy  && privacyPolicy.length){
      meta = [
        {
          title:privacyPolicy[0].transBlog[0].title,
            name: "description",
         content:t("searchPageMetaDescription"),
        }
    ]
    }
    return (
        <div>
          {meta && meta.length>0?
            <SiteSeo title={t("TermandCondition")} meta={meta}/>
          :""}
               <KeyWordsHelper  slugEntityClassType={null} slugEntityClass={null } url={null}/>
               <KeyWordsData keyWords={props.dehydratedState.queries.length>0&&props.dehydratedState.queries[0].state.data}/>
            <Main
            callback={callback}/>
       
           
        </div>
    )
}

export default index
export async function getServerSideProps({ locale,req}) {

  let dataOfQuery={}
  dataOfQuery.slugEntityClassType=["privacy-policy"]
  dataOfQuery.langCode=locale
  dataOfQuery.slugEntityClass=["blog"]
  dataOfQuery.cachKey="keywords-privacy-policy"
  await queryClient.prefetchQuery({queryKey:["key-words"],queryFn:async()=>await getKeywordsForBlogs(dataOfQuery,req),staleTime:60*10*1000})
    return {
      props: {
        dehydratedState:dehydrate(queryClient),
        // keyWords:JSON.stringify(getKeywords),
        ...(await serverSideTranslations(locale, ["common"]))
    
      }
    }};
